import { render, staticRenderFns } from "./EdenCustomersSelect.vue?vue&type=template&id=17de145d&scoped=true"
import script from "./EdenCustomersSelect.vue?vue&type=script&lang=js"
export * from "./EdenCustomersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de145d",
  null
  
)

export default component.exports